import type { RouteResources } from '@atlassian/react-resource-router';
/* eslint-disable import/order */
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import type { JiraLegacyRoute } from '@jira/platform__routing-route-types/src/JiraLegacyRoute.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { globalSettingsIssuesPermissionsEditRoute } from '@jira/router-routes__legacy-global-settings-issues-permissions-edit-routes/src/globalSettingsIssuesPermissionsEditRoute.tsx';
import { LegacyEditPermissionsPage } from './ui/legacy/pages/legacy-edit-permissions/index.tsx';

export const globalSettingsIssuesPermissionsEditRouteEntry: JiraLegacyRoute<RouteResources> =
	createLegacyEntry(globalSettingsIssuesPermissionsEditRoute, () => ({
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
		},

		// eslint-disable-next-line no-restricted-syntax
		component: LegacyEditPermissionsPage,
		resources: [navigationSidebarGlobalResource],
	}));
